import Component from '~/components/component';
import animRounding from '../../helpers/anim-rounding';

export default class SliderColumns extends Component {
    constructor(...args) {
        super(...args);

        this.params = {
            current: 0,
            next: 0,
            canClick: true
        }

        this._retrieveDOM();
        if(this._setCenteredWrapperHeight) {
            this._setCenteredWrapperHeight()
        }
    }

    _retrieveDOM() {
        this.dom.containerImages = this.dom.component.querySelectorAll(".anim-container");
        this.dom.images = this.dom.component.querySelectorAll(".anim-container .inner");
        this.dom.mask = this.dom.component.querySelectorAll(".anim-mask");
        this.dom.prev = this.dom.component.querySelector('.js-direction-previous');
        this.dom.next = this.dom.component.querySelector('.js-direction-next');
        this.dom.text = this.dom.component.querySelectorAll(".container-text");

        this.params.total = this.dom.containerImages.length - 1;
    }

    bind() {
        super.bind();

        //Animation rounding
        this.animRounding = new animRounding({
            container: this.dom.containerImages,
            mask: this.dom.mask,
            inner: this.dom.images
        }, this.params.current, this._onComplete.bind(this));

        //Event click for slider
        if (this.dom.containerImages.length > 1){
            this.dom.prev.addEventListener("click", this._process.bind(this, "prev"));
            this.dom.next.addEventListener("click", this._process.bind(this, "next"));
        }

    }

    _process(direction){

        if ( this.params.canClick == false)
            return;

        this.params.canClick = false;
        if ( direction == "next" && this.params.current < this.params.total){
            this.params.next++;
        }
        else if (direction == "next" && this.params.current == this.params.total) {
            this.params.next = 0;
        }
        else if (direction == "prev" && this.params.current > 0) {
            this.params.next--;
        }
        else if (direction == "prev" && this.params.current == 0) {
            this.params.next = this.params.total;
        }

        this.animText = new TimelineMax();

        this._animate();

    }

    _onComplete(indexCurrent) {
        this.params.current = indexCurrent;
        this.params.canClick = true;
    }


    /*
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// src/js/components/slider-columns/slider-columns.js